import { Dialog } from "@mui/material";
import { Button } from "react-bootstrap";
import { ToastContainer } from "react-toastify";
import "./OrderTableDialog.css";
import TableHeader from "./OrderTableDialog/TableHeader";
import TableList from "./OrderTableDialog/TableList";
import useTableDialog from "./OrderTableDialog/useTableDialog";

export default function OrderTableDialog(props) {
  const { show, onHide, restaurant, preSelectedTable } = props;

  const {
    loading,
    searchQuery,
    selectedTable,
    pendingTable,
    hideAvailableTables,
    infoContainerRef,
    topSectionRef,
    bottomContainerRef,
    handleSearchChange,
    handleCardClick,
    handletable,
    sortedTableInfos,
    handleScroll,
    setSelectedTable,
    setParentSelectedTable,
    setPendingTable,
  } = useTableDialog(props);

  return (
    <Dialog
      open={show}
      onClose={onHide}
      maxWidth='lg'
      fullWidth
      className='custom-table-dialog'
    >
      <ToastContainer />

      <div className='modal-content-wrapper'>
        <Button
          variant='light'
          className='close-button'
          onClick={() => {
            onHide();
            setParentSelectedTable(null);
            setSelectedTable(null);
            setPendingTable([]);
          }}
        >
          &times;
        </Button>

        <TableHeader
          selectedTable={pendingTable || selectedTable}
          restaurant={restaurant}
        />

        <div className='info-container' ref={infoContainerRef}>
          {loading ? (
            <p>Loading...</p>
          ) : (
            <>
              {typeof pendingTable === "object" &&
                Object.keys(pendingTable).length > 0 && (
                  <div className='gray-bar-container'>
                    <div className='gray-bar'></div>
                    <div>
                      <h4 className='bold-text'>{pendingTable.tableName}</h4>
                      <p className='mb-2'>{pendingTable.description}</p>
                      <p>
                        Available seat: {pendingTable.totalChairUnderThisTable}
                      </p>
                      <hr />
                    </div>
                  </div>
                )}
              <TableList
                tables={sortedTableInfos}
                searchQuery={searchQuery}
                handleSearchChange={handleSearchChange}
                handletable={handletable}
                pendingTable={pendingTable}
                hideAvailableTables={hideAvailableTables}
                bottomContainerRef={bottomContainerRef}
                handleScroll={handleScroll}
              />
            </>
          )}
        </div>

        <div className='table-btn-okclose'>
          <button
            className='btn btn-dark Okbtn-placeOrder'
            style={{ minWidth: "80px" }}
            onClick={() => {
              if (pendingTable) {
                setSelectedTable(pendingTable);
                setParentSelectedTable(pendingTable);
                handleCardClick(pendingTable);
              }
            }}
          >
            Ok
          </button>

          <button className='btn btn-dark Okbtn-placeOrder' onClick={onHide}>
            Cancel
          </button>
        </div>
      </div>
    </Dialog>
  );
}
